module.exports = __webpack_public_path__ + "images/serene-thumb__1xRpd.jpg";